import Images from '../assets/Images';
import { getFbThumbnailByAssetId } from '../fbApi/Image';

export const changeProtoypeThumbnail = async (adPrototype, token) => {
  const currentAdPrototype = adPrototype;
  await getProperThumbnail(
    currentAdPrototype,
    'adPrototype',
    (thumbnail) => {
      currentAdPrototype.thumbnail = thumbnail;
    },
    token
  );
  return Promise.resolve(currentAdPrototype);
};

export const getProperThumbnail = async (adObject, mode, callback, token) => {
  if (!adObject) {
    return;
  }
  const { type } = adObject;
  if (type === 'DAA') {
    await callback(Images.daaTypeCard);
  } else {
    try {
      const newThumbnail = await fetchThumbnail(adObject, token);
      if (mode === 'ad') {
        await callback(adObject.id, newThumbnail);
      } else {
        await callback(newThumbnail);
      }
    } catch (error) {
      if (!(error instanceof TypeError)) {
        console.log('Error in getProperThumbnail: ', error);
      }
    }
  }
};

export const fetchThumbnail = async (adObject, token, mode = '') => {
  const {
    type,
    thumbnail,
    video,
    asset_id: assetIdFromObject,
    cards
  } = adObject;
  let assetId = assetIdFromObject;

  const assetIdIsMissing = !assetId || isNaN(parseInt(assetId, 10));

  if (assetIdIsMissing && type === 'Carousel') {
    if (cards && cards.length > 0) {
      assetId = cards[0].asset_id;
    }
  }

  if (
    assetIdIsMissing &&
    type !== 'Carousel' &&
    type !== 'Still' &&
    mode !== 'card'
  ) {
    const placeholderImg =
      'https://s3.amazonaws.com/alexia-assets-prd/assets/c2ae4df2-bb89-406e-8eb8-139095051e4d.png';
    return Promise.resolve(placeholderImg);
  }

  if (
    (type === 'Still' || mode === 'card') &&
    decodeURIComponent(thumbnail).includes('https://s3.amazonaws.com/')
  ) {
    return Promise.resolve(decodeURIComponent(thumbnail));
  }

  if (
    thumbnail &&
    !decodeURIComponent(thumbnail).includes('https://s3.amazonaws.com/')
  ) {
    const firstFetchResult = await fetch(decodeURIComponent(thumbnail), {
      method: 'HEAD'
    });
    if (!firstFetchResult.ok || firstFetchResult.status === 403) {
      let newStillPath = video ? video.replace('mp4', 'jpg') : '';
      if (newStillPath.trim() !== '' && newStillPath) {
        const secondFetchResult = await fetch(
          decodeURIComponent(newStillPath),
          {
            method: 'HEAD',
            mode: 'no-cors'
          }
        );
        if (!secondFetchResult.ok || secondFetchResult.status === 403) {
          newStillPath = await recoverThumbnailFromFb(assetId, token);
        }
        return Promise.resolve(newStillPath);
      }
      const newThumbnail = await recoverThumbnailFromFb(assetId, token);
      return Promise.resolve(newThumbnail);
    }
    return Promise.resolve(thumbnail);
  }
  let newThumbnail = thumbnail || '';
  const firstFetchResult =
    newThumbnail.trim() !== ''
      ? await fetch(decodeURIComponent(newThumbnail), {
          method: 'HEAD'
        })
      : {};
  if (!firstFetchResult.ok || firstFetchResult.status === 403) {
    newThumbnail = await recoverThumbnailFromFb(assetId, token);
  }
  return Promise.resolve(decodeURIComponent(newThumbnail));
};

export const getProperCarouselCardThumbnail = async (card, callback, token) => {
  try {
    const { thumbnail, video, asset_id: assetId } = card;
    if (thumbnail && !thumbnail.includes('https://s3.amazonaws.com/')) {
      const firstFetchResult = await fetch(decodeURIComponent(thumbnail), {
        method: 'HEAD'
        // cache: 'no-cache'
      });
      let newStillPath = thumbnail;
      if (!firstFetchResult.ok || firstFetchResult.status === 403) {
        newStillPath = video ? video.replace('mp4', 'jpg') : '';
        if (newStillPath.trim() !== '' && newStillPath) {
          const secondFetchResult = await fetch(
            decodeURIComponent(newStillPath),
            {
              method: 'HEAD'
              // cache: 'no-cache'
            }
          );
          if (!secondFetchResult.ok || secondFetchResult.status === 403) {
            newStillPath = await recoverThumbnailFromFb(assetId, token);
          }
          callback(card.id, newStillPath);
        }
        const newThumbnail = await recoverThumbnailFromFb(assetId, token);
        callback(card.id, newThumbnail);
      } else {
        callback(card.id, thumbnail);
      }
    } else {
      let newThumbnail = thumbnail || '';
      const firstFetchResult =
        newThumbnail.trim() !== ''
          ? await fetch(decodeURIComponent(newThumbnail), {
              method: 'HEAD'
              // cache: 'no-cache'
            })
          : {};
      if (!firstFetchResult.ok || firstFetchResult.status === 403) {
        newThumbnail = await recoverThumbnailFromFb(assetId, token);
      }
      callback(card.id, newThumbnail);
    }
  } catch (error) {
    console.log('Error in getProperCarouseCardThumbnail: ', error);
  }
};

export const fetchCardThumbnails = (cards, token) => {
  const recoveredThumbnails = Promise.all(
    cards.map(async (card) => {
      const cardThumbnail = await fetchThumbnail(card, token);
      return Promise.resolve(cardThumbnail);
    })
  );
  return Promise.resolve(recoveredThumbnails);
};

export const recoverThumbnailFromFb = async (assetId, token) => {
  let newThumbnail = Images.missingThumbnail;
  if (assetId && assetId.trim() !== '' && !isNaN(parseInt(assetId, 10))) {
    const { thumbnails: thumbnailsResult } = await getFbThumbnailByAssetId(
      assetId,
      token
    );
    const { data: thumbnailData } = thumbnailsResult || {};
    newThumbnail =
      thumbnailData && thumbnailData.length > 0
        ? thumbnailData[0].uri
        : Images.missingThumbnail;
  }
  return newThumbnail;
};

export const checkIfThumbnailIsValid = async (adObject) => {
  const { thumbnail } = adObject;
  const decodedThumbnail = decodeURIComponent(thumbnail);

  try {
    const result = await fetch(decodedThumbnail, {
      method: 'HEAD'
    });
    const { ok, status } = result;
    const isThumbnailValid = ok || status === 200;
    return Promise.resolve(isThumbnailValid);
  } catch (error) {
    return Promise.resolve(true);
  }
};



// WEBPACK FOOTER //
// ./src/utils/thumbnailRecovery.js